import {Injectable, OnDestroy} from '@angular/core';
import {ExamenDefinitionModel} from '../../api/entity/examenDefinition.model';
import {ExamenDefinitionSummaryModel} from '../../api/entity/examenDefinitionSummary.model';
import {ExamenDefinitionSummaryDataServiceAdapter} from './ngrx/examenDefinitionSummaryDataService.adapter';
import {ExamenDefinitionRepository} from './ngrx/examenDefinition.repository';
import {AbstractFindAllService} from '../../../../core/service/v2/service/findAll/abstractFindAll.service';

@Injectable()
export class ExamenDefinitionSummaryFindAllService extends AbstractFindAllService<ExamenDefinitionModel, ExamenDefinitionSummaryModel>
    implements OnDestroy{

    constructor(repository: ExamenDefinitionRepository, dataServiceAdapter: ExamenDefinitionSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
